(function () {
  if (window.__swwQuickOptions) return;
  window.__swwQuickOptions = true;
  var modal, state;
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100) + ' ' + cur; }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function build() {
    modal = document.createElement('div');
    modal.className = 'sww-qo';
    modal.hidden = true;
    modal.innerHTML = '<div class="sww-qo__backdrop" data-qo-close></div><div class="sww-qo__dialog" role="dialog" aria-modal="true" aria-label="Choose options" tabindex="-1"><button type="button" class="sww-qo__close" data-qo-close aria-label="Close">&times;</button><div class="sww-qo__body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qo-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('sww-qo-open');
    if (state && state.opener) { try { state.opener.focus(); } catch (e) {} }
  }
  function findVariant() {
    var p = state.product, sel = state.selected;
    return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
  }
  function render() {
    var p = state.product, v = findVariant();
    var body = modal.querySelector('.sww-qo__body');
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
    var html = '<div class="sww-qo__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '</div>';
    html += '<div class="sww-qo__info"><h2 class="sww-qo__title">' + esc(p.title) + '</h2>';
    if (v) {
      html += '<div class="sww-qo__price">';
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s> ';
      html += '<strong>' + money(v.price) + '</strong></div>';
    }
    p.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = [];
      p.variants.forEach(function (vv) { if (values.indexOf(vv.options[i]) < 0) values.push(vv.options[i]); });
      if (p.variants.length === 1 && values[0] === 'Default Title') return;
      html += '<fieldset class="sww-qo__opt"><legend>' + esc(name) + ': <b>' + esc(state.selected[i]) + '</b></legend><div class="sww-qo__vals">';
      values.forEach(function (val) {
        var ok = p.variants.some(function (vv) { return vv.available && vv.options.every(function (o, k) { return k === i ? o === val : (o === state.selected[k]); }); });
        html += '<button type="button" class="sww-qo__val' + (val === state.selected[i] ? ' is-on' : '') + (ok ? '' : ' is-out') + '" data-opt="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
      });
      html += '</div></fieldset>';
    });
    var can = v && v.available;
    html += '<div class="sww-qo__qty"><span>Quantity</span><div><button type="button" data-qty="-1" aria-label="Less">&minus;</button><input type="number" min="1" value="' + state.qty + '" aria-label="Quantity"><button type="button" data-qty="1" aria-label="More">+</button></div></div>';
    html += '<button type="button" class="sww-qo__add" ' + (can ? '' : 'disabled') + '>' + (can ? 'Add to cart' : (v ? 'Sold out' : 'Unavailable')) + '</button>';
    html += '<div class="sww-qo__err" role="alert"></div>';
    html += '<a class="sww-qo__more" href="' + esc(state.url) + '">View full details &rarr;</a></div>';
    body.innerHTML = html;
    body.querySelectorAll('.sww-qo__val').forEach(function (b) {
      b.addEventListener('click', function () { state.selected[+b.dataset.opt] = b.dataset.val; render(); });
    });
    body.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty + (+b.dataset.qty));
        body.querySelector('.sww-qo__qty input').value = state.qty;
      });
    });
    body.querySelector('.sww-qo__qty input').addEventListener('change', function (e) {
      state.qty = Math.max(1, parseInt(e.target.value, 10) || 1); e.target.value = state.qty;
    });
    body.querySelector('.sww-qo__add').addEventListener('click', add);
  }
  function add() {
    var v = findVariant(), btn = modal.querySelector('.sww-qo__add'), err = modal.querySelector('.sww-qo__err');
    if (!v || !v.available) return;
    btn.disabled = true; btn.textContent = 'Adding…'; err.textContent = '';
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var payload = { id: v.id, quantity: state.qty };
    if (cart && cart.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status || res.errors) {
        err.textContent = res.description || res.message || 'Sorry, that could not be added.';
        btn.disabled = false; btn.textContent = 'Add to cart';
        return;
      }
      close();
      if (cart && cart.renderContents) { cart.renderContents(res); }
      else { window.location.href = (window.routes && routes.cart_url) || '/cart'; }
    }).catch(function () {
      err.textContent = 'Something went wrong. Please try again.';
      btn.disabled = false; btn.textContent = 'Add to cart';
    });
  }
  function open(opener) {
    var url = opener.getAttribute('data-product-url');
    if (!url) return;
    var handle = url.split('?')[0].split('/products/')[1];
    if (!handle) { window.location.href = url; return; }
    if (!modal) build();
    opener.classList.add('loading');
    fetch('/products/' + handle.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      if (tags.indexOf('photo upload') > -1) { window.location.href = url; return; }
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      state = { product: p, url: url, qty: 1, opener: opener, selected: first.options.slice() };
      render();
      modal.hidden = false;
      document.documentElement.classList.add('sww-qo-open');
      modal.querySelector('.sww-qo__dialog').focus();
    }).catch(function () { window.location.href = url; })
      .then(function () { opener.classList.remove('loading'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quick-add .quick-add__submit[data-product-url]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(btn);
  }, true);
})();
